(function() {
    const $$ = document.querySelectorAll.bind(document); //shortens document.querySelector 

    if (document.querySelectorAll('.secao-4d').length % 2 != 0 && !matchMedia('(max-width: 641px)').matches) { //fixes the issue of the vertical lines being in the wrong direction when the sum of all blocks are a odd number
        document.querySelector('.blocos-4d-ss').innerHTML =
            `
        .secao-4d:nth-last-of-type(2n) .secao-4d-inner:first-child {
            border-right: none;
            border-left: 2px solid #E07A8C;
        }

        .secao-4d-inner:first-child {
            border-left: none;
            border-right: 2px solid #E07A8C;
        }

        `;
    }

    //script that converts the usual youtube URL to the embed version
    $$('.ytIframe').forEach(k => {
        const urlAntiga = k.getAttribute('src');
        const videoEmbedUrl = 'https://www.youtube.com/embed/';
        let urlCorrigida;
        if (/youtu.be/.test(urlAntiga)) {
            urlCorrigida = videoEmbedUrl + urlAntiga.match(/be\/(.*)/)[0].replace(/be\//, '').replace(/&(.*)/, '');
        } else if (/youtube.com/.test(urlAntiga)) {
            urlCorrigida = videoEmbedUrl + urlAntiga.match(/v=(.*)/)[0].replace(/v=/, '').replace(/&(.*)/, '');
        }

        k.setAttribute('src', urlCorrigida);
    });

    //script that checks if the current block has more than 200 characters. And if that's the case,
    //it adds the "read more" button
    let readMoreBtsExpanded = [];
    let lastScrollPos;
    $$('.read-more-btn').forEach((k, i) => {
        readMoreBtsExpanded[i] = false;
        k.onclick = () => {
            const expandir = () => {
                k.innerText = 'Read Less';
                k.parentElement.previousElementSibling.style.maxHeight = '';
                k.nextElementSibling.style.display = 'none';
                k.closest('.secao-4d').classList.remove('max-450');
                lastScrollPos = document.documentElement.scrollTop;
                readMoreBtsExpanded[i] = true;
            };
            const retrair = () => {
                k.innerText = 'Read More';
                k.parentElement.previousElementSibling.style.maxHeight = '300px';
                k.nextElementSibling.style.display = 'block';
                k.closest('.secao-4d').classList.add('max-450');
                readMoreBtsExpanded[i] = false;
                scrollTo(0, lastScrollPos);
            };
            readMoreBtsExpanded[i] ? retrair() : expandir();
        }
    });


    $$('.secao-4d-inner-content').forEach(k => {
        if (k.innerText.length >= 600) {
            k.parentElement.querySelector('.read-more').style.display = 'flex';
            k.style.maxHeight = '300px';
            k.closest('.secao-4d').classList.add('max-450');
        }
    });
})();